import { createAction } from 'redux-actions';
import { Article } from '../contentful/contentfulClient';

export enum ArticlesActionType {
    ARTICLES_LOAD_START = 'ARTICLES:LOAD_START',
    ARTICLES_LOADING = 'ARTICLES:LOADING',
    ARTICLES_LOAD_SUCCESS = 'ARTICLES:LOAD_SUCCESS',
    ARTICLES_LOAD_FAILED = 'ARTICLES:LOAD_FAILED',
}

const articlesLoadStart = createAction<Array<string>>(ArticlesActionType.ARTICLES_LOAD_START);
const articlesLoading = createAction(ArticlesActionType.ARTICLES_LOADING);
const articlesLoadFailed = createAction(ArticlesActionType.ARTICLES_LOAD_FAILED);
const articlesLoadSuccess = createAction<Array<Article>>(ArticlesActionType.ARTICLES_LOAD_SUCCESS);

export const articlesActions = {
    articlesLoadStart,
    articlesLoading,
    articlesLoadFailed,
    articlesLoadSuccess
};


// WEBPACK FOOTER //
// ./src/article/ArticlesActions.ts